import { render } from "./ServiceProviderDashboardItem.vue?vue&type=template&id=30b5a86d"
import script from "./ServiceProviderDashboardItem.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDashboardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__